import Image from '@/components/Image';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { menuItemShow } from '@/routes';
import { Link } from '@inertiajs/react';

const ItemCard = ({ item }: { item: App.Data.MenuItemData }) => {
    return (
        <Card
            key={item.id}
            className="mt-0 flex flex-col bg-card pt-0 transition-shadow duration-300 hover:shadow-lg"
        >
            <div className="relative h-52 w-full">
                <Image
                    src={item.image}
                    alt={item.title}
                    placeholder={item.placeholder || ''}
                    className="rounded-t-lg"
                />
            </div>
            <CardContent className="flex-1">
                <div className="mb-3">
                    <p className="mb-1 flex gap-2 text-xs font-semibold tracking-wider text-primary uppercase">
                        {item.type
                            ? typeof item.type === 'object'
                                ? item.type?.name ?? ''
                                : item.type
                            : ''}
                        {item.type && item.category && (
                            <span className="h-4 w-px bg-gray-300" />
                        )}{' '}
                        {item.category
                            ? typeof item.category === 'object'
                                ? item.category?.name ?? ''
                                : item.category
                            : ''}
                    </p>
                    <h3 className="mb-2 text-lg font-bold text-foreground">
                        {item.title}
                    </h3>
                </div>
                <p className="line-clamp-2 text-sm text-muted-foreground">
                    {item.excerpt}
                </p>
            </CardContent>
            <CardFooter className="flex items-center justify-between border-t border-border pt-4">
                <span className="text-xl font-bold text-primary">
                    {item.price} EGP
                </span>
                <Link href={menuItemShow(item.slug || '')}>
                    <Button variant="secondary" size="sm">
                        View Details
                    </Button>
                </Link>
            </CardFooter>
        </Card>
    );
};

export default ItemCard;
